import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { IconButton } from '@mui/material';
import React from 'react';
import { useRecordContext } from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const PumpEnterButton = (props: any) => {
  const record: any = useRecordContext(props);
  const navigate = useNavigate();

  function openPump() {
    navigate(`/pumps/${record.id}`);
  }

  return (
    <>
      <IconButton onClick={() => openPump()}>
        <ArrowRightAltIcon />
      </IconButton>
    </>
  );
};
